var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"bloomreach-environment-warning"},[(!_vm.isProductionEnvironment)?_c('span',{staticClass:"text-EXPONDO-red-dark"},[_vm._v("\n    "+_vm._s(_vm.BLOOMREACH_MISSING_CONFIG_WARNING)+"\n  ")]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }